import { Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { AuthProvider } from '@/lib/supabase/AuthContext';
import { ProtectedRoute } from '@/lib/supabase/ProtectedRoute';
import { VaultProvider } from '@/lib/supabase/VaultContext';
import { WelcomeScreen } from '@/routes/welcome/WelcomeScreen';
import { VaultLayout } from '@/routes/vault/VaultLayout';
import { VaultHome } from '@/routes/vault/VaultHome';

/**
 * App — root component. Sets up the auth provider and router.
 *
 * Routing tree:
 *   /welcome       → public, lock screen
 *   /vault/*       → protected, behind auth
 *   everything else → redirect to /vault (or /welcome if unauthenticated
 *                     will be handled by ProtectedRoute)
 *
 * AnimatePresence keyed on the path gives us clean page transitions.
 */
export function App() {
  const location = useLocation();

  return (
    <AuthProvider>
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Navigate to="/vault" replace />} />
          <Route path="/welcome" element={<WelcomeScreen />} />
          <Route
            path="/vault/*"
            element={
              <ProtectedRoute>
                <VaultProvider>
                  <VaultLayout />
                </VaultProvider>
              </ProtectedRoute>
            }
          >
            <Route index element={<VaultHome />} />
            <Route path=":type" element={<VaultHome />} />
          </Route>
          <Route path="*" element={<Navigate to="/vault" replace />} />
        </Routes>
      </AnimatePresence>
    </AuthProvider>
  );
}